import { __decorate } from "tslib";
import { ApiResource } from '../../lib/api-decorators';
import { Api } from '../../lib/api.factory';
let UserResource = class UserResource extends Api {
    async getProfile() {
        return this.get('/profile');
    }
    async getProjects() {
        return this.get('/projects');
    }
    async getUsers(project) {
        return this.get('/users', { project });
    }
    async getUserList(params) {
        return this.get('/list', Object.assign({}, params));
    }
    async getUserById(userId) {
        return this.get(`/${userId}`);
    }
    async updateUserAccount(userId, expireDate, accountType) {
        return this.put(`/${userId}`, { expireDate, accountType });
    }
};
UserResource = __decorate([
    ApiResource('/user')
], UserResource);
export { UserResource };
